<template>
   <d-card class="card-small mb-4 pt-3">
      <!-- Card Header -->
      <d-card-header class="border-bottom text-center">
         <!-- User Avatar -->
         <div class="mb-3 mx-auto">
            <img class="rounded-circle" src="@/assets/images/avatars/0.jpg" width="110">
         </div>
         <!-- User Name -->
         <h4 class="mb-0">{{ user.firstName }} {{ user.lastName }}</h4>
         <!-- User Job Title -->
         <span class="text-muted d-block mb-2">Staff</span>
      </d-card-header>
      <d-list-group flush>
         <!-- User Meta -->
         <d-list-group-item>
            <span></span>
         </d-list-group-item>
      </d-list-group>
   </d-card>
</template>
<script>
import axios from "axios";
 
export default {
  name: 'user-details',
  data() {
    return {
      user : []
    };
  },
  mounted: function () {
    axios
      .get(process.env.VUE_APP_API+'api/user/Profile')
      .then(response => {
        this.user = response.data.result;
        // console.log(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  },
};
</script>